var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.showType == 'form-builder')?_c('b-form-group',{style:(_vm.properties.style),attrs:{"description":_vm.properties.description,"label":_vm.properties.question}},[_c('b-form-radio-group',{attrs:{"stacked":!_vm.properties.showInline}},_vm._l((_vm.properties.answers),function({ text, value },index){return _c('b-form-radio',{key:index,class:_vm.properties.showInline ? 'mr-3' : '',attrs:{"value":value}},[_vm._v(" "+_vm._s(text)+" ("+_vm._s(value)+") ")])}),1)],1):_vm._e(),(_vm.showType == 'properties')?_c('div',[_c('assessment-question-v1-properties',{attrs:{"formId":_vm.formId}})],1):_vm._e(),(
      _vm.showType == 'form-submitter' ||
        (_vm.showType == 'e-form' && _vm.properties.eFormEditable)
    )?_c('b-form-group',{staticStyle:{"font-size":"14px"},style:(_vm.properties.style),attrs:{"description":_vm.computedConditions.description
        ? _vm.superComputeFormSubmitterValue({
            elementId: this.id,
            property: 'description',
            value: _vm.properties.description,
            defaultValue: '',
            form: this.form
          })
        : _vm.properties.description,"label":_vm.computedConditions.question
        ? _vm.superComputeFormSubmitterValue({
            elementId: this.id,
            property: 'question',
            value: _vm.properties.question,
            defaultValue: '',
            form: this.form
          })
        : _vm.properties.question,"hidden":_vm.computedHidden,"state":_vm.state,"invalid-feedback":_vm.errors.join(', ')}},[_c('b-form-radio-group',{attrs:{"stacked":!_vm.properties.showInline},model:{value:(_vm.controlValue),callback:function ($$v) {_vm.controlValue=$$v},expression:"controlValue"}},_vm._l((_vm.computedConditions.answers
          ? _vm.superComputeFormSubmitterValue({
              elementId: this.id,
              property: 'answers',
              value: _vm.properties.answers,
              defaultValue: [],
              form: this.form
            })
          : _vm.properties.answers),function(answer,index){return _c('b-form-radio',{key:index,class:_vm.properties.showInline ? 'mr-3' : '',staticStyle:{"font-size":"14px"},attrs:{"value":answer}},[_vm._v(" "+_vm._s(answer.text)+" ")])}),1)],1):_vm._e(),(
      _vm.showType == 'form-viewer' ||
        (_vm.showType == 'e-form' && !_vm.properties.eFormEditable)
    )?_c('b-form-group',{style:(_vm.properties.style),attrs:{"label":_vm.computedConditions.question
        ? _vm.superComputeFormSubmitterValue({
            elementId: this.id,
            property: 'question',
            value: _vm.properties.question,
            defaultValue: '',
            form: this.form
          })
        : _vm.properties.question}},[_c('div',{class:_vm.properties.showInline ? 'd-flex flex-row flex-wrap' : ''},_vm._l((_vm.computedConditions.answers
          ? _vm.superComputeFormSubmitterValue({
              elementId: this.id,
              property: 'answers',
              value: _vm.properties.answers,
              defaultValue: [],
              form: this.form
            })
          : _vm.properties.answers),function({ text, value },optionIndex){return _c('div',{key:optionIndex,staticClass:"mr-3",attrs:{"value":value}},[(_vm.controlValue == value)?_c('b-icon-check-circle-fill',{staticClass:"text-primary"}):_c('b-icon-circle'),_vm._v(" "+_vm._s(text)+" ")],1)}),0)]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }